import httpClient from '@api/client';
import omit from 'lodash.omit';
export default {
    async getPrograms() {
        let { data } = await httpClient.get('/programs', {});
        return data.data;
    },
    async getProgram(id) {
        let { data } = await httpClient.get(`/programs/${id}`, {});
        return data.data;
    },
    async getStudent(id) {
        let { data } = await httpClient.get(`/students/${id}`, {});
        return data.data;
    },
    async getInstructors() {
        let { data } = await httpClient.get('/instructors', {});
        return data.data;
    },

    async getInstructor(params) {
        const {
            instructorId: instructor,
            sessionId: session,
            programId: program,
        } = params;

        let { data } = await httpClient.get(`/instructors/${instructor}`, {
            params: {
                session,
                program,
            },
        });
        return data.data;
    },
    async getMockStudents(count) {
        let { data } = await httpClient.get('/students/mock', {
            params: {
                count,
            },
        });
        return data;
    },
    async addStudents(params) {
        const {
            instructorId: instructor_id,
            programId: program_id,
            sessionId: session_id,
            students,
        } = params;
        let { data } = await httpClient.post('/students/multiple/create', {
            instructor_id,
            program_id,
            session_id,
            students,
        });
        return data;
    },
    async inviteStudent(id) {
        let { data } = await httpClient.get(`/students/invite/${id}`);
        return data;
    },
    async createProgram(program) {
        let { data } = await httpClient.post('/programs', program);
        return data.data;
    },
    async updateProgram(id, program) {
        let { data } = await httpClient.put(`/programs/${id}`, program);
        return data.data;
    },
    async createSession(programId, session) {
        let { data } = await httpClient.post(
            `/programs/${programId}/sessions`,
            session
        );
        return data.data;
    },
    async updateSession(programId, session) {
        let { data } = await httpClient.put(
            `/programs/${programId}/sessions/${session.id}`,
            omit(session, 'id')
        );
        return data.data;
    },
    async deleteSession(session) {
        let { data } = await httpClient.delete(`/sessions/${session.id}`);
        return data.data;
    },
    async createInstructors(id, payload) {
        let { data } = await httpClient.post(
            `/programs/${id}/instructors/`,
            payload
        );
        return data;
    },
    async updateInstructor(id, payload) {
        let { data } = await httpClient.put(
            `/programs/${id}/instructors/${payload.id}`,
            omit(payload, 'id')
        );
        return data.data;
    },
    async sendNotification(payload) {
        await httpClient.post('/notifications', payload);
    },
    async getInstructorSessionStudents({ programId, instructorId, sessionId }) {
        let { data } = await httpClient.get(
            `/programs/${programId}/instructors/${instructorId}/sessions/${sessionId}/students`
        );
        return data.data;
    },
    async instructorAssignStudents(payload) {
        let { data } = await httpClient.post(
            `/programs/${payload.programId}/instructors/assign`,
            payload
        );
        return data.data;
    },
    async resendInstructorInvite(instructorId) {
        let { data } = await httpClient.get(
            `/instructors/resend/${instructorId}`
        );
        return data.data;
    },
    async inactivateInstructor(instructorId) {
        let { data } = await httpClient.delete(`/instructors/${instructorId}`);
        return data.data;
    },
    async getProgramStudents(programId) {
        let { data } = await httpClient.get(`/programs/${programId}/students`);
        return data.data;
    },
    async getStudents(params) {
        let { data } = await httpClient.get(`/students/query`, { params });
        return data.data;
    },
    async getProgramInstructors(params) {
        let { data } = await httpClient.get(`/instructors/query`, { params });
        return data.data;
    },
    async graduateStudents(payload) {
        let { data } = await httpClient.post(
            `/students/multiple/update`,
            payload
        );
        return data;
    },
    async saveLogoImage(image) {
        let { data } = await httpClient.post(`/programs/logo`, {
            image,
        });
        return data.data;
    },
};
